import moment from 'moment';

/**
 * Interface to define external configuration settings for the Calendar app.
 */
export enum CalendarViewMode {
    GRID,
    LIST
}

export enum CalendarEventMode {
    All,
    PERFORMANCES,
    DIGITAL,
    EVENTS
}

export enum CalendarDeviceMode {
    DESKTOP,
    MOBILE
}


export interface ICalendarSettings {
    loadWrappingMonthDates: boolean;
    saveHistory: boolean;
    monthsOnCalendar: moment.Moment[];
    desktopToMobileTransitionWidth: string;
    scrollToTopAppearanceOffset: number;
    calendarDeviceMode: CalendarDeviceMode;
    calendarViewMode: CalendarViewMode;
}

const calendarEntry = document.getElementById("calendar-entry-js");

export const defaultCalendarSettings: ICalendarSettings = {
    loadWrappingMonthDates: false,
    saveHistory: false,
    calendarDeviceMode: CalendarDeviceMode.DESKTOP,
    calendarViewMode: CalendarViewMode.GRID,
    monthsOnCalendar: [],
    desktopToMobileTransitionWidth: calendarEntry ? calendarEntry.getAttribute("data-calendar-breakpoint") : "48em",
    scrollToTopAppearanceOffset: parseInt(calendarEntry ? calendarEntry.getAttribute("data-scroll-to-top-offset") : "500")
}